// extracted by mini-css-extract-plugin
export default {"container":"layout_container__i6e9m","main":"layout_main__gcYyy"};